<div class="title-error" *ngIf="this.clicked && control?.errors">
  <p *ngIf="control?.errors?.['required']">{{name}} is Required</p>
  <p *ngIf="control?.errors?.['minlength']">{{name}} must be at least {{minLengthValue}} characters long</p>
  <p *ngIf="control?.errors?.['maxlength']">{{name}} must be at most 20 characters long</p>
  <p *ngIf="control?.errors?.['ageInvalid']">{{name}} must be at least 14 years</p>
  <p *ngIf="showSampleValues && control?.errors?.['pattern']">
    {{name}} has an invalid format. Example: {{ getSampleValue() }}
  </p>
</div>

<div class="security-error" *ngIf="hasSecurityViolation() && (clicked || control?.touched)">
  Invalid input format. Only letters, numbers, spaces, hyphens, and apostrophes are allowed.
</div>